import { takeLatest, put } from 'redux-saga/effects';
import { call, select, all } from 'typed-redux-saga';
import { getUserId } from 'state/session/selectors';
import { transformAddress } from 'data/transformers/address';
import { transformPaymentsAccount } from 'data/transformers/payments-account';
import * as api from 'data/api';
import { UiState } from 'constants/ui';
import { actions } from './slice';
export function* getDefaultFormValues() {
  var _paymentsAccount, _paymentsAccount2, _paymentsAccount3, _paymentsAccount4;

  const currentUserId = yield* select(getUserId);
  if (!currentUserId) return;
  const [billingResponse, paymentsResponse] = yield* all([call(api.getDefaultBillingAddress), call(api.getPaymentsAccount, currentUserId)]);
  let address = null;
  let paymentsAccount = null;
  let isSsnNumberRequired = false;
  let isPersonalIdNumberRequired = false;
  let isAccountDetailsLocked = false;
  let isBalanceActivated = false;
  let isNationalityRequired = false;
  let agreementHint = '';

  if ('user_address' in billingResponse) {
    address = transformAddress(billingResponse.user_address);
  }

  if ('payments_account' in paymentsResponse && paymentsResponse.payments_account) {
    paymentsAccount = transformPaymentsAccount(paymentsResponse.payments_account);
  }

  if ('locked_account_details' in paymentsResponse) {
    isAccountDetailsLocked = paymentsResponse.locked_account_details;
  }

  if ('ssn_number_required' in paymentsResponse) {
    isSsnNumberRequired = paymentsResponse.ssn_number_required;
  }

  if ('balance_activated' in paymentsResponse) {
    isBalanceActivated = paymentsResponse.balance_activated;
  }

  if ('personal_id_number_required' in paymentsResponse) {
    isPersonalIdNumberRequired = paymentsResponse.personal_id_number_required;
  }

  if ('nationality_required' in paymentsResponse) {
    isNationalityRequired = paymentsResponse.nationality_required;
  }

  if ('agreement_hint' in paymentsResponse) {
    agreementHint = paymentsResponse.agreement_hint;
  }

  const form = {
    firstName: ((_paymentsAccount = paymentsAccount) === null || _paymentsAccount === void 0 ? void 0 : _paymentsAccount.firstName) || '',
    lastName: ((_paymentsAccount2 = paymentsAccount) === null || _paymentsAccount2 === void 0 ? void 0 : _paymentsAccount2.lastName) || '',
    birthdate: ((_paymentsAccount3 = paymentsAccount) === null || _paymentsAccount3 === void 0 ? void 0 : _paymentsAccount3.birthdate) || '',
    ssn: '',
    personalIdNumber: '',
    nationality: ((_paymentsAccount4 = paymentsAccount) === null || _paymentsAccount4 === void 0 ? void 0 : _paymentsAccount4.nationality) || null
  };
  yield put(actions.getDefaultFormValuesSuccess({
    form
  }));
  yield* all([put(actions.setCanChange({
    canChange: !isAccountDetailsLocked
  })), put(actions.setIsSsnNumberRequired({
    status: isSsnNumberRequired
  })), put(actions.setIsPersonalIdNumberRequired({
    status: isPersonalIdNumberRequired
  })), put(actions.setIsBalanceActivated({
    status: isBalanceActivated
  })), put(actions.setIsNationalityRequired({
    status: isNationalityRequired
  })), put(actions.setAgreementHint({
    status: agreementHint
  }))]);
  yield put(actions.setAddress({
    address
  }));
  yield put(actions.setStatus({
    status: UiState.Success
  }));
}
export default function* saga() {
  yield takeLatest(actions.getDefaultFormValuesRequest.type, getDefaultFormValues);
}